export default __webpack_public_path__ + "static/media/confirmedSignOut.66163951.svg";